import React from "react";
import PropTypes from "prop-types";
import selectOptions from "shared/prop_types/selectOptions";
import FormRowField from "shared/react_components/FormRowField";
import FormRadioGroup from "shared/react_components/FormRadioGroup";
import { CheckboxWithLabel } from "shared/formik/formik_helpers";
import get from "lodash/get";

const NotificationCheckbox = ({ name, label, optionsField, options }) => (
  <>
    <FormRowField name={name}>
      {({ field, form }) => (
        <CheckboxWithLabel field={field} form={form} label={label} />
      )}
    </FormRowField>
    {optionsField && options && !!options.length && (
      <FormRadioGroup
        className="ml-5"
        name={optionsField}
        options={options}
        isDisabled={ values => !get(values, name) }
      />
    )}
  </>
);

export const checkboxProps = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  optionsField: PropTypes.string,
  options: selectOptions
};

NotificationCheckbox.propTypes = checkboxProps;

export default NotificationCheckbox;
